import React from "react";
import SectionTemplate from "../../Template/SectionTemplate";
import WorkIncapacityDateOfClaimFromField from "./WorkIncapacityFields/WorkIncapacityDateOfClaimFromField";
import WorkIncapacityDateOfClaimToField from "./WorkIncapacityFields/WorkIncapacityDateOfClaimToField";
import WorkIncapacityTimeOfClaimField from "./WorkIncapacityFields/WorkIncapacityTimeOfClaimField";
import WorkIncapacityAdditionalInjuryDescriptionField from "./WorkIncapacityFields/WorkIncapacityAdditionalInjuryDescriptionField";
import { StoreType } from "../../../../../../redux/store/store";
import { useSelector } from "react-redux";
import { shouldRenderSection } from "../../../../../../redux/reducers/visibilityMatrixesReducer";
import { AttentionBlock } from "@nn-design-system/react-component-library";
import { Box } from "@mui/material";

function getDaysBetween(from: any, to: any) {
    if (!from || !to) return 0;
    const fromDate = new Date(from);
    const toDate = new Date(to);
    if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) return 0;
    return Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;
}

function isOrangeContract(contractNumber?: string | null) {
    return contractNumber?.length === 8;
}

const WorkIncapacitySection: React.FC = () => {
    const visibilityMatrixes = useSelector(
        (state: StoreType) => state.visibilityMatrixesState
    );

    const dateOfClaimFrom = useSelector(
        (state: StoreType) =>
            state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
                (model) => model.typeOfClaimEnum === 2
            )?.dateOfClaimFrom
    );

    const dateOfClaimTo = useSelector(
        (state: StoreType) =>
            state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
                (model) => model.typeOfClaimEnum === 2
            )?.dateOfClaimTo
    );

    const contractNumbers = useSelector(
        (state: StoreType) => state.claimState.personModel.contractList
    );

    const allContractsOrange = contractNumbers?.every(c => isOrangeContract(c));

    const showWarning =
        !!dateOfClaimFrom &&
        !!dateOfClaimTo &&
        !allContractsOrange &&
        getDaysBetween(dateOfClaimFrom, dateOfClaimTo) < 29;

    if (!shouldRenderSection("incapacity", visibilityMatrixes)) return null;
    return (
        <SectionTemplate heading="Pracovní neschopnost" iconName="Calendar">
            <WorkIncapacityDateOfClaimFromField />
            <WorkIncapacityDateOfClaimToField />
            <WorkIncapacityTimeOfClaimField />
            {showWarning && (
                <Box sx={{ gridColumn: { xs: "span 1", sm: "span 2" } }}>
                    <AttentionBlock variant="Warning">
                        <Box>
                            Zdá se, že na plnění nemáte dle pojistných podmínek nárok, pracovní neschopnost plníme až od 29. dne. Výjimka je, pokud jste během pracovní neschopnosti strávil/a alespoň 3 dny v nemocnici. Zvažte, zda splňujete podmínky pro plnění a chcete pokračovat v nahlášení.
                        </Box>
                    </AttentionBlock>
                </Box>
            )}
            <WorkIncapacityAdditionalInjuryDescriptionField />
        </SectionTemplate>
    );
};

export default WorkIncapacitySection;
